export default "__VITE_ASSET__B9ZHw7TW__"